import {useEffect, useState} from "react";

export const useDrag = props => {
  const {onDrop, onDragOverStateChange, allowedType} = props ?? {};
  const [isDraggingOver, setIsDraggingOver] = useState(false);

  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();

    setIsDraggingOver(false);

    // exit silently if no file or more than 1 file were dropped in
    // or file type is not allowed
    const {files} = e.dataTransfer;
    if (!files?.length || files.length > 1) {
      return;
    }
    if (allowedType) {
      const regExp = new RegExp(`^${allowedType}/*`);
      if (!regExp.test(files[0].type)) {
        return;
      }
    }

    onDrop?.(files[0]);
  };

  const handleDragOver = e => {
    e.preventDefault();
    e.stopPropagation();

    if (!isDraggingOver) {
      setIsDraggingOver(true);
    }
  };

  const handleDragOut = e => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggingOver(false);
  };

  useEffect(() => {
    onDragOverStateChange?.(isDraggingOver);
  }, [isDraggingOver]);

  return {isDraggingOver, handleDrop, handleDragOver, handleDragOut};
};
